<ng-container *transloco="let t; read: 'ime.common.confirm-final'">
<div class="modal-header" ngxModalDraggable>
  <h3 class="modal-title pull-left">
    {{t('Save changes to final')}}
  </h3>
  <button type="button" class="btn-close pull-right" (click)="close()" aria-label="Close">
  </button>
</div>
<div class="modal-body">
  <p>{{t('You are modifying Final version of entity. Confirm Save or create draft version with current changes')}}</p>
</div>
<div class="modal-footer">
  <div class="text-end">
    <button type="button" class="btn btn-success btn-lg px-5"
            (click)="close(null, 'save')">
      {{t('Save')}}
    </button>
    <button type="button" class="btn btn-default btn-lg ms-4 px-8" (click)="close(null, 'create-draft')">
      {{t('Create Draft')}}
    </button>
    <button type="button" class="btn btn-default btn-lg ms-4 px-8" (click)="close()">
      {{t('Cancel')}}
    </button>
  </div>
</div>
</ng-container>
